<app-document-viewer-page label="Planes y Servicios" [url]="url">
</app-document-viewer-page>

